import { render } from "./BaseBackButton.vue?vue&type=template&id=79a28566"
import script from "./BaseBackButton.vue?vue&type=script&lang=ts"
export * from "./BaseBackButton.vue?vue&type=script&lang=ts"
script.render = render

export default script